import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import "./PublicLayout.css";

function PublicFooter() {
    return (
        <footer className="public-footer">
            <div className="public-container public-footer-inner">
                <div className="public-footer-links">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/terms">Terms &amp; Conditions</Link>
                    <Link to="/user-request">User Requests</Link>
                    <Link to="/become-partner">Become Partner</Link>
                </div>
                <div className="public-footer-contact">
                    <span>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <a href="mailto:connect@zinea.app">connect@zinea.app</a>
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faPhone} />
                        <a href="tel:+918800404288">+91 880 0404 288</a>
                    </span>
                </div>
                <p className="public-footer-copy">
                    &copy; {new Date().getFullYear()} Zinea Lifestyles - All Rights
                    Reserved.
                </p>
            </div>
        </footer>
    );
}

export default PublicFooter;
